<template>
    <aside class="aside aside-fixed">
        <div class="aside-header">
            <a href="/" class="aside-logo">
                <img src="../../assets/img/RubiesLogo.png" width="150" height="50">
            </a>
            <a href="#" class="aside-menu-link">
                <MenuIcon @click="show(true)"/>
                <XIcon @click="show(false)"/>
            </a>
            <a href id="chatContentClose" class="burger-menu d-none">
                <ArrowLeftIcon />
            </a>
            <a href id="contactContentHide" class="burger-menu d-none">
                <ArrowLeftIcon />
            </a>
        </div>
        <div class="aside-body">
            <div class="aside-loggedin">
                <div class="d-flex align-items-center justify-content-start">
                    <a href class="avatar">
                        <img src="https://via.placeholder.com/500" class="rounded-circle" alt/>
                    </a>
                    <div class="aside-alert-link">
                        <a href="" title="Sign out" @click="logout"><LogOutIcon /></a>
                    </div>
                </div>
                <div class="aside-loggedin-user">
                    <a
                            href="#loggedinMenu"
                            class="d-flex align-items-center justify-content-between mg-b-2"
                            data-toggle="collapse"
                    >
                        <h6 class="tx-semibold mg-b-0">{{ auth.name.toUpperCase() }}</h6>
                        <i data-feather="chevron-down"></i>
                    </a>
                    <p class="tx-color-03 tx-12 mg-b-0">{{ auth.roles }}</p>
                </div>
                <div class="collapse" id="loggedinMenu">
                    <ul class="nav nav-aside mg-b-0">
<!--                        <li class="nav-item">-->
<!--                            <a href class="nav-link">-->
<!--                                <i data-feather="edit"></i>-->
<!--                                <span>Edit Profile</span>-->
<!--                            </a>-->
<!--                        </li>-->
                        <li class="nav-item">
                            <a href @click="logout" class="nav-link">
                                <LogOutIcon />
                                <span>Sign Out</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- aside-loggedin -->
            <base-sidebar :menus="menu"></base-sidebar>
        </div>
    </aside>
</template>

<script>
    import BaseSidebar from "../../views/template/layouts/component/baseComponent/BaseSidebar";
    import {LogOutIcon, ArrowLeftIcon, MenuIcon, XIcon } from "vue-feather-icons"
    import { mapState } from "vuex"
    import PerfectScrollbar from "perfect-scrollbar";
    import $ from 'jquery'


    export default {
        components: {
            BaseSidebar,
            LogOutIcon,ArrowLeftIcon, MenuIcon, XIcon
        },
        name: "SideBar",
        props: ['layout'],
        data() {
            return {
                accountservicemenu: [
                    {
                        header: true,
                        classType: 'nav-label mt-3',
                        title: 'Dashboard',
                    },

                    {
                        icon: 'dashboard',
                        classType: 'nav-item',
                        title: 'Dashboard',
                        href: '/account/',
                    },


                    {
                        header: true,
                        classType: "nav-label mt-3",
                        title: "Payments Services"
                    },

                    {
                        icon: 'chevron-multiple',
                        classType: 'nav-item',
                        title: 'Funds Transfer - Multiple',
                        href: '/payments/funds-transfer-multiple',
                    },
                    {
                        icon: 'chevron',
                        classType: 'nav-item',
                        title: 'Funds Transfer - Single',
                        href: '/payments/funds-transfer-single',
                    },
                    {
                        icon: 'auth',
                        classType: 'nav-item',
                        title: 'Authorization Queue',
                        href: '/payments/auth-request',
                    },

                    {
                        header: true,
                        classType: 'nav-label mt-3',
                        title: 'Account Service Menu',
                    },

                    {
                        icon: 'accounts',
                        classType: 'nav-item',
                        title: 'Account View',
                        href: '/account/account-view',
                    },
                    {
                        icon: 'activities',
                        classType: 'nav-item',
                        title: 'Account Activities',
                        href: '/account/account-activities',
                    },
                    {
                      icon: 'accounts',
                      classType: 'nav-item',
                      title: 'Beneficiary Managament',
                      href: '/account/beneficiary-management',
                    },

                    {
                        icon: 'statements',
                        classType: 'nav-item',
                        title: 'Account Statement',
                        href: '/account/account-statement',
                    },

                    {
                        icon: 'officers',
                        classType: 'nav-item',
                        title: 'Officers',
                        href: '#',
                        coming: true

                    },

                    {
                        icon: 'signatories',
                        classType: 'nav-item',
                        title: 'Signatories',
                        href: '#',
                        coming: true

                    },

                    {
                      header: true,
                      classType: 'nav-label mt-3',
                      title: 'Support',
                    },

                    {
                      icon: 'statements',
                      classType: 'nav-item',
                      title: 'Customer Support',
                      href: '/account/support',
                    }






                ],
                paymentmenu: [
                    {
                        header: true,
                        classType: 'nav-label mt-3',
                        title: 'Dashboard',
                    },

                    {
                        icon: 'dashboard',
                        classType: 'nav-item',
                        title: 'Dashboard',
                        href: '/account/',
                    },


                    {
                        header: true,
                        classType: "nav-label mt-3",
                        title: "Payments Services"
                    },

                    {
                        icon: 'chevron-multiple',
                        classType: 'nav-item',
                        title: 'Funds Transfer - Multiple',
                        href: '/payments/funds-transfer-multiple',
                    },
                    {
                        icon: 'chevron',
                        classType: 'nav-item',
                        title: 'Funds Transfer - Single',
                        href: '/payments/funds-transfer-single',
                    },
                    {
                        icon: 'auth',
                        classType: 'nav-item',
                        title: 'Authorization Queue',
                        href: '/payments/auth-request',
                    },

                    {
                        header: true,
                        classType: 'nav-label mt-3',
                        title: 'Account Service Menu',
                    },

                    {
                        icon: 'accounts',
                        classType: 'nav-item',
                        title: 'Account View',
                        href: '/account/account-view',
                    },
                    {
                        icon: 'activities',
                        classType: 'nav-item',
                        title: 'Account Activities',
                        href: '/account/account-activities',
                    },
                    {
                        icon: 'accounts',
                        classType: 'nav-item',
                        title: 'Beneficiary Managament',
                        href: '/account/beneficiary-management',
                    },
                    {
                        icon: 'statements',
                        classType: 'nav-item',
                        title: 'Account Statement',
                        href: '/account/account-statement',
                    },

                    {
                        icon: 'officers',
                        classType: 'nav-item',
                        title: 'Officers',
                        href: '#',
                        coming: true

                    },

                    {
                        icon: 'signatories',
                        classType: 'nav-item',
                        title: 'Signatories',
                        href: '#',
                        coming: true

                    },


                    {
                      header: true,
                      classType: 'nav-label mt-3',
                      title: 'Support',
                    },

                    {
                      icon: 'statements',
                      classType: 'nav-item',
                      title: 'Customer Support',
                      href: '/account/support',
                    }


                ],
                adminmenu:[
                  {
                    header: true,
                    classType: 'nav-label mt-3',
                    title: 'Menu',
                  },

                  {
                    icon: 'dashboard',
                    classType: 'nav-item',
                    title: 'All Batches',
                    href: '/admin/stats',
                  },
                  {
                    icon: 'officers',
                    classType: 'nav-item',
                    title: 'All Users',
                    href: '/admin/users',
                  },
                  {
                    icon: 'officers',
                    classType: 'nav-item',
                    title: 'All Companies',
                    href: '/admin/companies',
                  },

                  {
                    header: true,
                    classType: 'nav-label mt-3',
                    title: 'Settings',
                  },


                  {
                    icon: 'statements',
                    classType: 'nav-item',
                    title: 'Admin Settings',
                    href: '/admin/settings',
                  },

                ]
            }
        },
        computed: {
            ...mapState(['auth']),
            menu() {
                if (this.layout === 'accountservice') {
                    return this.accountservicemenu
                } else if(this.layout === 'admin')  {
                    return this.adminmenu
                }else {
                  return this.paymentmenu
                }
            },
        },
        methods:{
            show: function(type){
                const app = $('.app-contact');
                type ===true ? app.addClass('show-aside') : app.removeClass('show-aside');
            },
            logout(){
                this.$store.commit("auth/reset", {});
            }
        },
        mounted() {
          console.log(this.layout)
            const psSidebar = new PerfectScrollbar('.aside-body', {
                suppressScrollX: true
            });
            psSidebar.isAlive = true
        }
    }
</script>

<style scoped>
</style>
